(function () {
  const productRequestCache = new Map();
  let activeMetaElement = null;
  let activePlanRefresh = null;
  let activeEventController = null;

  function normalizeCheckoutEmail(value) {
    const email = String(value || '').trim().slice(0, 254);
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return '';
    return email;
  }

  function splitCheckoutName(value) {
    const fullName = String(value || '').trim().replace(/\s+/g, ' ').slice(0, 160);
    if (!fullName) return { firstName: '', lastName: '' };
    const parts = fullName.split(' ');
    return {
      firstName: parts.shift() || '',
      lastName: parts.join(' ')
    };
  }

  function buildCheckoutUrl(meta, origin) {
    const checkoutUrl = new URL('/checkout', origin || window.location.origin);
    const email = normalizeCheckoutEmail(meta && meta.email);
    const name = splitCheckoutName(meta && meta.nombreContacto);

    if (email) checkoutUrl.searchParams.set('checkout[email]', email);
    if (name.firstName) {
      checkoutUrl.searchParams.set('checkout[shipping_address][first_name]', name.firstName);
    }
    if (name.lastName) {
      checkoutUrl.searchParams.set('checkout[shipping_address][last_name]', name.lastName);
    }

    return checkoutUrl.pathname + checkoutUrl.search;
  }

  function initQuizResult() {
    const root = document;
    const metaEl = root.querySelector('[data-quiz-meta]');
    if (!metaEl) return;
    if (metaEl === activeMetaElement) return;
    if (activeEventController) activeEventController.abort();
    activeEventController = new AbortController();
    const eventOptions = { signal: activeEventController.signal };
    activeMetaElement = metaEl;

    const statusEl = root.querySelector('[data-quiz-status]');
    const recipeCards = Array.from(root.querySelectorAll('[data-quiz-recipe]'));
    const periodCards = Array.from(root.querySelectorAll('[data-quiz-period]'));
    const checkoutButtons = Array.from(root.querySelectorAll('[data-quiz-checkout], [data-quiz-checkout-secondary]'));
    const retakeLinks = Array.from(root.querySelectorAll('[data-quiz-retake]'));
    const hero = metaEl.closest('.qr-hero');
    const editToggle = hero && hero.querySelector('[data-quiz-edit-toggle]');
    const editForm = hero && hero.querySelector('[data-quiz-plan-editor]');
    const configEl = root.querySelector('[data-quiz-config]');
    const globalConfigEl = root.getElementById('FlippoQuizConfig');
    let text = {};
    let globalConfig = {};
    let planViewRequestId = 0;
    let checkoutInFlight = false;
    let editingInFlight = false;

    try {
      text = configEl ? JSON.parse(configEl.textContent || '{}') : {};
    } catch (e) {
      text = {};
    }

    try {
      globalConfig = globalConfigEl ? JSON.parse(globalConfigEl.textContent || '{}') : {};
    } catch (e) {
      globalConfig = {};
    }

    text = Object.assign({
      calculating: 'Calculando plan...',
      resolving: 'Resolviendo productos...',
      cart: 'Preparando carrito...',
      redirect: 'Redirigiendo al pago...',
      renewal: 'Después se renueva como suscripción mensual a [price_day]€/día. Cancela cuando quieras.',
      cta: 'Empezar la prueba de [nombre] →',
      noFlavor: 'Selecciona al menos una receta',
      selectedRecipesSingle: 'Recibirá <b>[count] receta</b>.',
      selectedRecipesPlural: 'Recibirá <b>[count] recetas</b>.',
      selectedRecipesEmpty: 'Selecciona al menos una receta para [nombre].'
    }, text);

  const PLAN_HANDLE_BY_BAGS = {
    '9-300': 'mi-plan-flippo-9-mensual',
    '14-300': 'mi-plan-flippo-14-mensual',
    '19-300': 'mi-plan-flippo-19u-400g-x-mensual',
    '28-300': 'mi-plan-flippo-28u-300g-x-mensual',
    '28-400': 'mi-plan-flippo-28u-400g-x-mensual',
    '35-400': 'mi-plan-flippo-17u-400g-x-semanas',
    '42-400': 'mi-plan-flippo-42u-400g-x-semanas',
    '49-400': 'mi-plan-flippo-48',
    '56-400': 'mi-plan-flippo-56-x-mensual',
    '63-400': 'mi-plan-flippo-56-x-mensual-copia',
    '70-400': 'mi-plan-flippo-63-x-mensual-copia'
  };

  const INTERNAL_HANDLES = {
    chicken: { 300: 'flippo-pollo-copia', 400: 'flippo-pollo-400' },
    fish: { 300: 'flippo-salmon-copia', 400: 'flippo-salmon-400' },
    beef: { 300: 'flippo-ternera-copia', 400: 'flippo-ternera-400' }
  };

  const PUPPY_TABLE = {
    1:{price_monthly:41.93, price_day:1.5, g_day:100, bag_size:300, bags:9},
    2:{price_monthly:41.93, price_day:1.5, g_day:100, bag_size:300, bags:9},
    3:{price_monthly:41.93, price_day:1.5, g_day:100, bag_size:300, bags:9},
    4:{price_monthly:49.28, price_day:1.76, g_day:150, bag_size:300, bags:14},
    5:{price_monthly:49.28, price_day:1.76, g_day:150, bag_size:300, bags:14},
    6:{price_monthly:60.26, price_day:2.15, g_day:200, bag_size:300, bags:19},
    7:{price_monthly:60.26, price_day:2.15, g_day:200, bag_size:300, bags:19},
    8:{price_monthly:72.34, price_day:2.58, g_day:300, bag_size:300, bags:28},
    9:{price_monthly:84.41, price_day:3.01, g_day:400, bag_size:400, bags:28},
    10:{price_monthly:84.41, price_day:3.01, g_day:400, bag_size:400, bags:28},
    11:{price_monthly:84.41, price_day:3.01, g_day:400, bag_size:400, bags:28},
    12:{price_monthly:92.29, price_day:3.3, g_day:500, bag_size:400, bags:35},
    13:{price_monthly:92.29, price_day:3.3, g_day:500, bag_size:400, bags:35},
    14:{price_monthly:115.39, price_day:4.12, g_day:600, bag_size:400, bags:42},
    15:{price_monthly:115.39, price_day:4.12, g_day:600, bag_size:400, bags:42},
    16:{price_monthly:115.39, price_day:4.12, g_day:600, bag_size:400, bags:42},
    17:{price_monthly:126.89, price_day:4.53, g_day:700, bag_size:400, bags:49},
    18:{price_monthly:126.89, price_day:4.53, g_day:700, bag_size:400, bags:49},
    19:{price_monthly:126.89, price_day:4.53, g_day:700, bag_size:400, bags:49},
    20:{price_monthly:136.6, price_day:4.88, g_day:800, bag_size:400, bags:56},
    21:{price_monthly:136.6, price_day:4.88, g_day:800, bag_size:400, bags:56},
    22:{price_monthly:148.6, price_day:5.31, g_day:900, bag_size:400, bags:63},
    23:{price_monthly:148.6, price_day:5.31, g_day:900, bag_size:400, bags:63},
    24:{price_monthly:156.97, price_day:5.61, g_day:1000, bag_size:400, bags:70},
    25:{price_monthly:156.97, price_day:5.61, g_day:1000, bag_size:400, bags:70},
    26:{price_monthly:156.97, price_day:5.61, g_day:1000, bag_size:400, bags:70},
    27:{price_monthly:156.97, price_day:5.61, g_day:1000, bag_size:400, bags:70}
  };

  const ADULT_TABLE = {
    1:{price_monthly:41.93, price_day:1.5, g_day:100, bag_size:300, bags:9},
    2:{price_monthly:41.93, price_day:1.5, g_day:100, bag_size:300, bags:9},
    3:{price_monthly:41.93, price_day:1.5, g_day:100, bag_size:300, bags:9},
    4:{price_monthly:49.28, price_day:1.76, g_day:150, bag_size:300, bags:14},
    5:{price_monthly:49.28, price_day:1.76, g_day:150, bag_size:300, bags:14},
    6:{price_monthly:60.26, price_day:2.15, g_day:200, bag_size:300, bags:19},
    7:{price_monthly:60.26, price_day:2.15, g_day:200, bag_size:300, bags:19},
    8:{price_monthly:60.26, price_day:2.15, g_day:200, bag_size:300, bags:19},
    9:{price_monthly:60.26, price_day:2.15, g_day:200, bag_size:300, bags:19},
    10:{price_monthly:60.26, price_day:2.15, g_day:200, bag_size:300, bags:19},
    11:{price_monthly:72.34, price_day:2.58, g_day:300, bag_size:300, bags:28},
    12:{price_monthly:72.34, price_day:2.58, g_day:300, bag_size:300, bags:28},
    13:{price_monthly:72.34, price_day:2.58, g_day:300, bag_size:300, bags:28},
    14:{price_monthly:72.34, price_day:2.58, g_day:300, bag_size:300, bags:28},
    15:{price_monthly:72.34, price_day:2.58, g_day:300, bag_size:300, bags:28},
    16:{price_monthly:84.41, price_day:3.01, g_day:400, bag_size:400, bags:28},
    17:{price_monthly:84.41, price_day:3.01, g_day:400, bag_size:400, bags:28},
    18:{price_monthly:84.41, price_day:3.01, g_day:400, bag_size:400, bags:28},
    19:{price_monthly:84.41, price_day:3.01, g_day:400, bag_size:400, bags:28},
    20:{price_monthly:84.41, price_day:3.01, g_day:400, bag_size:400, bags:28},
    21:{price_monthly:84.41, price_day:3.01, g_day:400, bag_size:400, bags:28},
    22:{price_monthly:84.41, price_day:3.01, g_day:400, bag_size:400, bags:28},
    23:{price_monthly:92.29, price_day:3.3, g_day:500, bag_size:400, bags:35},
    24:{price_monthly:92.29, price_day:3.3, g_day:500, bag_size:400, bags:35},
    25:{price_monthly:92.29, price_day:3.3, g_day:500, bag_size:400, bags:35},
    26:{price_monthly:92.29, price_day:3.3, g_day:500, bag_size:400, bags:35},
    27:{price_monthly:92.29, price_day:3.3, g_day:500, bag_size:400, bags:35},
    28:{price_monthly:115.39, price_day:4.12, g_day:600, bag_size:400, bags:42},
    29:{price_monthly:115.39, price_day:4.12, g_day:600, bag_size:400, bags:42},
    30:{price_monthly:115.39, price_day:4.12, g_day:600, bag_size:400, bags:42},
    31:{price_monthly:115.39, price_day:4.12, g_day:600, bag_size:400, bags:42},
    32:{price_monthly:115.39, price_day:4.12, g_day:600, bag_size:400, bags:42},
    33:{price_monthly:115.39, price_day:4.12, g_day:600, bag_size:400, bags:42},
    34:{price_monthly:126.89, price_day:4.53, g_day:700, bag_size:400, bags:49},
    35:{price_monthly:126.89, price_day:4.53, g_day:700, bag_size:400, bags:49},
    36:{price_monthly:126.89, price_day:4.53, g_day:700, bag_size:400, bags:49},
    37:{price_monthly:126.89, price_day:4.53, g_day:700, bag_size:400, bags:49},
    38:{price_monthly:136.6, price_day:4.88, g_day:800, bag_size:400, bags:56},
    39:{price_monthly:136.6, price_day:4.88, g_day:800, bag_size:400, bags:56},
    40:{price_monthly:136.6, price_day:4.88, g_day:800, bag_size:400, bags:56}
  };

  const ADULT_BRACKETS = [
    { min: 1, max: 3 },
    { min: 4, max: 5 },
    { min: 6, max: 10 },
    { min: 11, max: 15 },
    { min: 16, max: 22 },
    { min: 23, max: 27 },
    { min: 28, max: 33 },
    { min: 34, max: 37 },
    { min: 38, max: 40 }
  ];

  function setStatus(message) {
    if (statusEl) statusEl.textContent = message || '';
  }

  function setLoading(state) {
    if (editToggle) editToggle.disabled = state;
    checkoutButtons.forEach(function (button) {
      button.disabled = state;
      button.classList.toggle('is-loading', state);
      button.setAttribute('aria-busy', state ? 'true' : 'false');
    });
  }

  function toNumber(value) {
    if (value == null) return null;
    const n = Number(String(value).replace(',', '.').trim());
    return Number.isFinite(n) ? n : null;
  }

  function formatMoney(value) {
    if (!Number.isFinite(value)) return '';
    return value.toFixed(2).replace('.', ',') + '€';
  }

  function calculateTrialPrice(monthlyPrice, trialRatio, discountPercent) {
    return monthlyPrice * trialRatio * ((100 - discountPercent) / 100);
  }

  function replaceTokens(template, values) {
    return String(template || '').replace(/\[([^\]]+)\]/g, function (_, token) {
      return values[token] != null ? values[token] : '';
    });
  }

  function referralDiscountBadge(referral, percentage) {
    if (!(percentage > 0)) return '';
    const template = referral && referral.discountText
      ? referral.discountText
      : '[descuento]% de descuento en tu primera caja';
    return replaceTokens(template, {
      descuento: percentage
    });
  }

  function normalizeActivityLabel(label) {
    const s = (label || '').toLowerCase().trim();
    if (s.includes('incansable')) return 'high';
    if (s.includes('aventur')) return 'mid';
    return 'low';
  }

  function findBracketIndex(kg) {
    for (let i = 0; i < ADULT_BRACKETS.length; i += 1) {
      const b = ADULT_BRACKETS[i];
      if (kg >= b.min && kg <= b.max) return i;
    }
    return -1;
  }

  function applyAdultActivityBracket(weightRoundedKg, activityLabel) {
    if (normalizeActivityLabel(activityLabel) !== 'high') return weightRoundedKg;
    const index = findBracketIndex(weightRoundedKg);
    if (index === -1 || !ADULT_BRACKETS[index + 1]) return weightRoundedKg;
    return ADULT_BRACKETS[index + 1].min;
  }

  function ageInMonths(year, month) {
    const y = parseInt(year, 10);
    const m = parseInt(month, 10);
    if (!Number.isFinite(y) || !Number.isFinite(m) || m < 1 || m > 12) return 36;
    const now = new Date();
    return (now.getFullYear() - y) * 12 + ((now.getMonth() + 1) - m);
  }

  function clampKg(kg, min, max) {
    return Math.max(min, Math.min(max, kg));
  }

  function getPlanFromTables(pesoKgRaw, birthYear, birthMonth, activityLabel) {
    const weight = toNumber(pesoKgRaw);
    if (!weight) return null;
    const puppy = ageInMonths(birthYear, birthMonth) < 12;
    if (!puppy && weight > 40) return null;

    if (puppy) {
      const kg = clampKg(Math.round(weight), 1, 27);
      const row = PUPPY_TABLE[kg];
      return row ? Object.assign({}, row, { kg_effective: kg, puppy: true }) : null;
    }

    const rounded = Math.round(weight);
    const activeWeight = applyAdultActivityBracket(rounded, activityLabel);
    const kg = clampKg(activeWeight, 1, 40);
    const row = ADULT_TABLE[kg];
    return row ? Object.assign({}, row, { kg_effective: kg, puppy: false }) : null;
  }

  function readMeta() {
    const d = metaEl.dataset;
    return {
      nombreMascota: d.nombreMascota || '',
      raza: d.raza || '',
      pesoKg: toNumber(d.pesoKg),
      actividad: d.actividad || '',
      esterilizado: d.esterilizado || '',
      cumpleMes: toNumber(d.cumpleMes),
      cumpleAno: toNumber(d.cumpleAno),
      email: d.checkoutEmail || '',
      nombreContacto: d.checkoutName || ''
    };
  }

  function getSelectedPeriod() {
    return periodCards.find(function (card) { return card.dataset.selected === 'true'; }) || periodCards[0] || null;
  }

  function getSelectedRecipes() {
    return recipeCards.filter(function (card) { return card.dataset.selected === 'true'; });
  }

  function ensureInitialSelection() {
    if (recipeCards.length && !getSelectedRecipes().length) setRecipeSelected(recipeCards[0], true);
    if (periodCards.length && !periodCards.some(function (card) { return card.dataset.selected === 'true'; })) {
      setPeriodSelected(periodCards[0]);
    }
  }

  function setRecipeSelected(card, selected) {
    card.dataset.selected = selected ? 'true' : 'false';
    card.classList.toggle('is-selected', selected);
    card.setAttribute('aria-pressed', selected ? 'true' : 'false');
    const state = card.querySelector('[data-quiz-recipe-state]');
    if (state) state.textContent = selected ? card.dataset.selectedText : card.dataset.unselectedText;
  }

  function setPeriodSelected(card) {
    periodCards.forEach(function (period) {
      const selected = period === card;
      period.dataset.selected = selected ? 'true' : 'false';
      period.classList.toggle('is-selected', selected);
      period.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
    updatePlanView();
  }

  function splitEven(totalUnits, flavors) {
    const base = Math.floor(totalUnits / flavors.length);
    const remainder = totalUnits % flavors.length;
    const result = {};
    flavors.forEach(function (flavor, index) {
      result[flavor] = base + (index < remainder ? 1 : 0);
    });
    return result;
  }

  function buildLineProperties(meta, plan, splitTrial, splitMonthly, period, referral, sellingPlanName) {
    const props = {
      _Nombre: meta.nombreMascota || '',
      _Raza: meta.raza || '',
      _Nacimiento: meta.cumpleAno || '',
      _Peso: meta.pesoKg != null ? meta.pesoKg + 'kg' : '',
      _Actividad: meta.actividad || '',
      _Periodo: referral && sellingPlanName ? sellingPlanName : (period ? period.dataset.label : ''),
      _LOCKED: '1'
    };
    Object.assign(props, referralLineProperties(referral));
    const labels = { chicken: 'Pollo', fish: 'Pescado', beef: 'Ternera' };
    ['chicken', 'fish', 'beef'].forEach(function (key) {
      if (splitTrial && splitTrial[key] != null) props['_Box de ' + labels[key] + ': Trial'] = splitTrial[key] + ' x' + plan.bag_size + ' g';
      if (splitMonthly && splitMonthly[key] != null) props['_Box de ' + labels[key] + ': Mensual'] = splitMonthly[key] + ' x' + plan.bag_size + ' g';
    });
    return props;
  }

  function referralLineProperties(referral) {
    if (!referral || !referral.code) return {};
    return {
      _Referral: referral.code,
      _referral_code: referral.code,
      _mgm_referral_code: referral.code,
      _mgm_referral_source: 'member_get_member'
    };
  }

  function normalizeSellingPlanId(value) {
    const raw = String(value == null ? '' : value).trim();
    if (!raw) return '';
    return raw.includes('/') ? raw.split('/').filter(Boolean).pop() : raw;
  }

  function getActiveReferral() {
    if (!window.FlippoReferral || typeof window.FlippoReferral.getActive !== 'function') return null;
    try {
      return window.FlippoReferral.getActive();
    } catch (error) {
      return null;
    }
  }

  function findSellingPlanAllocation(variant, preferredSellingPlanId, handle) {
    const allocations = variant && Array.isArray(variant.selling_plan_allocations)
      ? variant.selling_plan_allocations
      : [];
    const preferredId = normalizeSellingPlanId(preferredSellingPlanId);

    if (!preferredId) return allocations[0] || null;

    const allocation = allocations.find(function (item) {
      return normalizeSellingPlanId(item.selling_plan_id) === preferredId;
    });

    if (!allocation) {
      throw new Error('El selling plan referral ' + preferredId + ' no está disponible para ' + handle + '.');
    }

    return allocation;
  }

  function allocationPrice(adjustment, fallback) {
    const cents = adjustment && toNumber(adjustment.price);
    if (cents != null) return cents / 100;
    return fallback;
  }

  function findSellingPlan(product, sellingPlanId) {
    const preferredId = normalizeSellingPlanId(sellingPlanId);
    const groups = product && Array.isArray(product.selling_plan_groups)
      ? product.selling_plan_groups
      : [];

    for (const group of groups) {
      const plans = Array.isArray(group.selling_plans) ? group.selling_plans : [];
      const plan = plans.find(function (item) {
        return normalizeSellingPlanId(item.id) === preferredId;
      });
      if (plan) return plan;
    }

    return null;
  }

  function sellingPlanDays(sellingPlan) {
    const pieces = [sellingPlan && sellingPlan.name];
    if (sellingPlan && Array.isArray(sellingPlan.options)) {
      sellingPlan.options.forEach(function (option) { pieces.push(option && option.value); });
    }
    const match = pieces.filter(Boolean).join(' ').match(/(\d+)\s*d[ií]as?/i);
    return match ? toNumber(match[1]) : null;
  }

  function sellingPlanBadge(sellingPlan) {
    const adjustment = sellingPlan && Array.isArray(sellingPlan.price_adjustments)
      ? sellingPlan.price_adjustments[0]
      : null;
    if (!adjustment || adjustment.value_type !== 'percentage') return '';
    const percentage = toNumber(adjustment.value);
    const orders = toNumber(adjustment.order_count);
    if (!percentage) return '';
    if (orders && orders > 1) return percentage + '% de descuento en tus ' + orders + ' primeras cajas';
    if (orders === 1) return percentage + '% de descuento en tu primera caja';
    return percentage + '% de descuento';
  }

  async function getFirstVariantByHandle(handle, preferredSellingPlanId) {
    let productRequest = productRequestCache.get(handle);
    if (!productRequest) {
      productRequest = fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (res) {
          if (!res.ok) throw new Error('No pude cargar el producto: ' + handle);
          return res.json();
        })
        .catch(function (error) {
          productRequestCache.delete(handle);
          throw error;
        });
      productRequestCache.set(handle, productRequest);
    }
    const product = await productRequest;
    const variant = product.variants && product.variants[0];
    if (!variant || !variant.id) throw new Error('Producto sin variante: ' + handle);
    const allocation = findSellingPlanAllocation(variant, preferredSellingPlanId, handle);
    const sellingPlan = allocation ? findSellingPlan(product, allocation.selling_plan_id) : null;
    const adjustments = allocation && Array.isArray(allocation.price_adjustments)
      ? allocation.price_adjustments
      : [];
    const basePrice = variant.price / 100;
    const allocationPriceCents = allocation ? toNumber(allocation.price) : null;
    const firstCyclePrice = allocation
      ? allocationPrice(adjustments[0], allocationPriceCents != null ? allocationPriceCents / 100 : basePrice)
      : null;
    const renewalPrice = allocation
      ? allocationPrice(adjustments[adjustments.length - 1], firstCyclePrice)
      : null;
    const sellingPlanId = allocation ? toNumber(normalizeSellingPlanId(allocation.selling_plan_id)) : null;

    return {
      variantId: variant.id,
      price: basePrice,
      firstCyclePrice: firstCyclePrice,
      renewalPrice: renewalPrice,
      sellingPlanId: sellingPlanId,
      sellingPlanName: sellingPlan ? sellingPlan.name : '',
      sellingPlanDays: sellingPlanDays(sellingPlan),
      sellingPlanBadge: sellingPlanBadge(sellingPlan)
    };
  }

  async function resolvePlanVariant(monthlyBags, bagSize, preferredSellingPlanId) {
    const key = monthlyBags + '-' + bagSize;
    const handle = PLAN_HANDLE_BY_BAGS[key];
    if (!handle) throw new Error('No hay plan mapeado para ' + monthlyBags + ' bolsas de ' + bagSize + 'g');
    return getFirstVariantByHandle(handle, preferredSellingPlanId);
  }

  async function clearCart() {
    const res = await fetch('/cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } });
    if (!res.ok) throw new Error('No se pudo vaciar el carrito (' + res.status + ').');
  }

  async function addItems(items) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    });
    if (!res.ok) {
      const body = await res.text().catch(function () { return ''; });
      let message = 'No se pudo añadir al carrito (' + res.status + ').';
      try {
        const parsed = JSON.parse(body);
        message += ' ' + (parsed.description || parsed.message || '');
      } catch (e) {
        if (body) message += ' ' + body;
      }
      throw new Error(message.trim());
    }
    return res.json();
  }

  async function updateReferralCartAttributes(referral) {
    if (!referral || !referral.code) return;
    const attributes = {
      referral_code: referral.code,
      _referral_code: referral.code,
      mgm_referral_code: referral.code,
      _mgm_referral_code: referral.code,
      mgm_referral_source: 'member_get_member'
    };
    const res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    });
    if (!res.ok) throw new Error('No se pudo guardar la atribución del referido.');
  }

  function appendAutomaticProduct(items) {
    const variantId = toNumber(globalConfig.automaticProductVariantId);
    if (!variantId) return;

    const alreadyIncluded = items.some(function (item) {
      return toNumber(item && item.id) === variantId &&
        !item.selling_plan &&
        item.properties &&
        item.properties._QuizFlippo === '1';
    });
    if (alreadyIncluded) return;

    items.push({
      id: variantId,
      quantity: 1,
      properties: {
        _QuizFlippo: '1',
        _Auto: 'Producto adicional del quiz'
      }
    });
  }

  function selectedPeriodData() {
    const period = getSelectedPeriod();
    if (!period) return null;
    return {
      el: period,
      label: period.dataset.label || '',
      days: toNumber(period.dataset.days) || 14,
      trialRatio: Math.max(0.01, (toNumber(period.dataset.trialRatioPercent) || 50) / 100),
      discount: Math.max(0, Math.min(100, toNumber(period.dataset.discountPercent) || 0)),
      badge: period.dataset.badge || ''
    };
  }

  async function updatePlanView() {
    const requestId = ++planViewRequestId;
    const meta = readMeta();
    const plan = meta ? getPlanFromTables(meta.pesoKg, meta.cumpleAno, meta.cumpleMes, meta.actividad) : null;
    const period = selectedPeriodData();
    if (!plan || !period) return;

    const grams = root.querySelector('[data-quiz-grams]');
    const discount = root.querySelector('[data-quiz-discount]');
    const oldPrice = root.querySelector('[data-quiz-old-price]');
    const newPrice = root.querySelector('[data-quiz-new-price]');
    const pricePeriod = root.querySelector('[data-quiz-price-period]');
    const renewal = root.querySelector('[data-quiz-renewal]');
    const cta = root.querySelector('[data-quiz-cta-label]');

    if (grams) grams.textContent = plan.g_day + 'g';
    root.querySelectorAll('[data-quiz-grams-value]').forEach(function (el) { el.textContent = plan.g_day; });
    root.querySelectorAll('[data-quiz-pet-meta]').forEach(function (el) {
      const pieces = [];
      if (meta.pesoKg != null) pieces.push(meta.pesoKg + ' kg');
      if (meta.actividad) pieces.push('actividad ' + meta.actividad);
      el.textContent = pieces.join(' · ');
    });
    const referral = getActiveReferral();
    const applyReferralPlan = Boolean(referral && referral.applyPlan);
    const applyReferralPricing = Boolean(referral && referral.applyPricing);
    const referralSellingPlanId = applyReferralPlan ? referral.sellingPlanId : null;
    const referralDiscountPercent = applyReferralPricing ? toNumber(referral.discountPercent) : null;
    if (applyReferralPlan && !referralSellingPlanId) {
      setStatus('Falta configurar el selling plan del referral en los ajustes del tema.');
      return;
    }
    let monthlyPrice = plan.price_monthly;
    let renewalPrice = monthlyPrice;
    let trialPrice = calculateTrialPrice(monthlyPrice, period.trialRatio, period.discount);
    let displayPeriodLabel = period.label;
    let displayPeriodDays = period.days;
    let displayBadge = period.badge;
    if (applyReferralPricing && referralDiscountPercent != null) {
      trialPrice = calculateTrialPrice(monthlyPrice, period.trialRatio, referralDiscountPercent);
      displayBadge = referralDiscountBadge(referral, referralDiscountPercent);
    }

    function renderPlanView() {
      if (discount) {
        discount.textContent = displayBadge;
        discount.hidden = !displayBadge;
      }
      root.querySelectorAll('[data-quiz-discount-badge]').forEach(function (el) {
        el.textContent = displayBadge || '';
        el.hidden = !displayBadge;
      });
      if (applyReferralPlan) {
        root.querySelectorAll('[data-quiz-period-heading], [data-quiz-period-summary]').forEach(function (el) {
          el.textContent = displayPeriodLabel;
        });
      }

      const priceDay = renewalPrice / 28;
      const tokens = {
        nombre: meta.nombreMascota,
        price_day: formatMoney(priceDay).replace('€', ''),
        monthly_price: formatMoney(renewalPrice),
        periodo: displayPeriodLabel,
        days: displayPeriodDays
      };
      const renewalTemplate = renewal && renewal.dataset.template ? renewal.dataset.template : text.renewal;

      if (oldPrice) oldPrice.textContent = formatMoney(monthlyPrice);
      if (newPrice) newPrice.textContent = formatMoney(trialPrice);
      const pricePeriodText = applyReferralPlan
        ? '/ ' + displayPeriodLabel
        : '/ ' + displayPeriodLabel + ' · prueba';
      if (pricePeriod) pricePeriod.textContent = pricePeriodText;
      root.querySelectorAll('[data-quiz-price-period]').forEach(function (el) { el.textContent = pricePeriodText; });
      root.querySelectorAll('[data-quiz-old-price-all]').forEach(function (el) { el.textContent = formatMoney(monthlyPrice); });
      root.querySelectorAll('[data-quiz-new-price-all]').forEach(function (el) { el.textContent = formatMoney(trialPrice); });
      root.querySelectorAll('[data-quiz-days-all]').forEach(function (el) { el.textContent = displayPeriodDays; });
      root.querySelectorAll('[data-quiz-period-label-all]').forEach(function (el) { el.textContent = displayPeriodLabel; });
      if (renewal) renewal.innerHTML = replaceTokens(renewalTemplate, tokens);
      root.querySelectorAll('[data-quiz-renewal]').forEach(function (el) {
        const template = el.dataset.template || text.renewal;
        el.innerHTML = replaceTokens(template, tokens);
      });
      if (cta) cta.textContent = replaceTokens(text.cta, tokens);
      root.querySelectorAll('[data-quiz-cta-label-all]').forEach(function (el) { el.textContent = replaceTokens(text.cta, tokens); });
      updateRecipesRecap();
    }

    renderPlanView();

    try {
      const main = await resolvePlanVariant(plan.bags, plan.bag_size, referralSellingPlanId);
      if (main && main.price) monthlyPrice = main.price;
      if (main && Number.isFinite(main.firstCyclePrice)) trialPrice = main.firstCyclePrice;
      if (main && Number.isFinite(main.renewalPrice)) renewalPrice = main.renewalPrice;
      if (applyReferralPlan && main) {
        displayPeriodLabel = main.sellingPlanName || displayPeriodLabel;
        displayPeriodDays = main.sellingPlanDays || displayPeriodDays;
        displayBadge = main.sellingPlanBadge;
      }
      if (applyReferralPricing && referralDiscountPercent != null) {
        if (!applyReferralPlan) {
          trialPrice = calculateTrialPrice(monthlyPrice, period.trialRatio, referralDiscountPercent);
        }
        displayBadge = referralDiscountBadge(referral, referralDiscountPercent);
      }
      if (applyReferralPlan) setStatus('');
    } catch (e) {
      monthlyPrice = plan.price_monthly;
      renewalPrice = monthlyPrice;
      if (applyReferralPricing && referralDiscountPercent != null) {
        trialPrice = calculateTrialPrice(monthlyPrice, period.trialRatio, referralDiscountPercent);
        displayBadge = referralDiscountBadge(referral, referralDiscountPercent);
      } else {
        trialPrice = calculateTrialPrice(monthlyPrice, period.trialRatio, period.discount);
      }
      if (applyReferralPlan) setStatus(e && e.message ? e.message : 'El plan referral no está disponible.');
    }
    if (requestId !== planViewRequestId || eventOptions.signal.aborted) return;
    renderPlanView();
  }

  async function handleCheckout() {
    if (checkoutInFlight || editingInFlight) return;
    checkoutInFlight = true;

    try {
      setLoading(true);
      setStatus(text.calculating);

      if (
        window.FlippoReferral &&
        typeof window.FlippoReferral.whenReady === 'function'
      ) {
        await window.FlippoReferral.whenReady();
      }

      const meta = readMeta();
      const plan = meta ? getPlanFromTables(meta.pesoKg, meta.cumpleAno, meta.cumpleMes, meta.actividad) : null;
      const period = selectedPeriodData();
      const referral = getActiveReferral();
      const applyReferralPlan = Boolean(referral && referral.applyPlan);
      const referralSellingPlanId = applyReferralPlan ? referral.sellingPlanId : null;
      if (applyReferralPlan && !referralSellingPlanId) {
        throw new Error('Falta configurar el selling plan del referral en los ajustes del tema.');
      }
      if (!plan) throw new Error('No se pudo determinar el plan con los datos actuales');
      if (!period) throw new Error('Selecciona un periodo');

      const selectedRecipes = getSelectedRecipes();
      if (!selectedRecipes.length) throw new Error(text.noFlavor);

      const flavors = selectedRecipes.map(function (card) { return card.dataset.flavor; });
      const monthlyBags = plan.bags;
      const trialBags = referral && referral.matchPlanQuantity
        ? monthlyBags
        : Math.max(1, Math.round(monthlyBags * period.trialRatio));
      const splitMonthly = splitEven(monthlyBags, flavors);
      const splitTrial = splitEven(trialBags, flavors);

      setStatus(text.resolving);
      const main = await resolvePlanVariant(monthlyBags, plan.bag_size, referralSellingPlanId);
      const fallbackSellingPlanId = main && main.sellingPlanId ? main.sellingPlanId : null;
      const items = [];

      for (const card of selectedRecipes) {
        const flavor = card.dataset.flavor;
        const qty = splitTrial[flavor] || 0;
        if (!qty) continue;

        const configuredHandle = card.getAttribute('data-handle-' + plan.bag_size);
        const fallbackHandle = INTERNAL_HANDLES[flavor] && INTERNAL_HANDLES[flavor][plan.bag_size];
        const handle = configuredHandle || fallbackHandle;
        if (!handle) throw new Error('No hay handle interno para ' + flavor + ' ' + plan.bag_size);

        const child = await getFirstVariantByHandle(handle, referralSellingPlanId);
        const childSellingPlanId = child.sellingPlanId || fallbackSellingPlanId;
        if (!childSellingPlanId) throw new Error('Falta selling_plan_id para el producto: ' + handle);

        items.push({
          id: child.variantId,
          quantity: qty,
          selling_plan: childSellingPlanId,
          properties: {
            _LOCKED: '1',
            _Auto: referral ? 'Receta plan referral' : 'Receta trial',
            _Receta: card.dataset.title || flavor,
            ...referralLineProperties(referral)
          }
        });
      }

      if (!fallbackSellingPlanId) throw new Error('Falta selling_plan_id para el plan principal');
      items.push({
        id: main.variantId,
        quantity: 1,
        selling_plan: fallbackSellingPlanId,
        properties: buildLineProperties(meta, plan, splitTrial, splitMonthly, period.el, referral, main.sellingPlanName)
      });
      appendAutomaticProduct(items);

      setStatus(text.cart);
      await clearCart();
      await addItems(items);
      await updateReferralCartAttributes(referral);

      setStatus(text.redirect);
      window.location.href = buildCheckoutUrl(meta);
    } catch (error) {
      console.error(error);
      setStatus(error && error.message ? error.message : 'Error');
      setLoading(false);
      checkoutInFlight = false;
    }
  }

  function updateRecipesRecap() {
    const selected = getSelectedRecipes();
    const recap = root.querySelector('[data-quiz-recipes-recap]');
    if (!recap) return;
    const meta = readMeta() || {};
    if (!selected.length) {
      recap.classList.add('is-warning');
      recap.innerHTML = replaceTokens(text.selectedRecipesEmpty, { nombre: meta.nombreMascota || '' });
      root.querySelectorAll('[data-quiz-recipes-names]').forEach(function (el) { el.textContent = '—'; });
      return;
    }
    recap.classList.remove('is-warning');
    const template = selected.length === 1 ? text.selectedRecipesSingle : text.selectedRecipesPlural;
    recap.innerHTML = replaceTokens(template, { count: selected.length, nombre: meta.nombreMascota || '' });
    const names = selected.map(function (card) { return card.dataset.title || ''; }).filter(Boolean).join(' · ');
    root.querySelectorAll('[data-quiz-recipes-names]').forEach(function (el) { el.textContent = names; });
  }

  if (editToggle && editForm) {
    const weightInput = editForm.querySelector('[data-quiz-edit-weight]');
    const activityInput = editForm.querySelector('[data-quiz-edit-activity]');
    const cancelButton = editForm.querySelector('[data-quiz-edit-cancel]');
    const errorEl = editForm.querySelector('[data-quiz-edit-error]');
    const activities = { low: 'Amante del Sofá', mid: 'Aventurero Casual', high: 'Explorador Incansable' };

    function closeEditor() {
      editForm.hidden = true;
      editToggle.setAttribute('aria-expanded', 'false');
      editToggle.focus();
    }

    editToggle.hidden = false;
    editToggle.addEventListener('click', function () {
      if (checkoutInFlight || editingInFlight) return;
      if (!editForm.hidden) {
        closeEditor();
        return;
      }
      const meta = readMeta();
      weightInput.value = meta.pesoKg == null ? '' : meta.pesoKg;
      activityInput.value = activities[normalizeActivityLabel(meta.actividad)];
      errorEl.hidden = true;
      editForm.hidden = false;
      editToggle.setAttribute('aria-expanded', 'true');
      weightInput.focus();
    }, eventOptions);

    cancelButton.addEventListener('click', closeEditor, eventOptions);
    editForm.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !editingInFlight) {
        event.preventDefault();
        closeEditor();
      }
    }, eventOptions);

    editForm.addEventListener('submit', async function (event) {
      event.preventDefault();
      if (checkoutInFlight || editingInFlight || !editForm.reportValidity()) return;
      const weight = toNumber(weightInput.value);
      const activity = activityInput.value;
      if (weight == null || weight < 1 || weight > 40 || !Object.values(activities).includes(activity)) return;
      const meta = readMeta();
      const plan = getPlanFromTables(weight, meta.cumpleAno, meta.cumpleMes, activity);
      if (!plan || !selectedPeriodData()) {
        errorEl.textContent = editForm.dataset.error;
        errorEl.hidden = false;
        return;
      }
      editingInFlight = true;
      errorEl.hidden = true;
      editForm.setAttribute('aria-busy', 'true');
      const controls = Array.from(editForm.querySelectorAll('input, select, button'));
      controls.forEach(function (control) { control.disabled = true; });
      setLoading(true);
      let saved = false;
      try {
        const referral = getActiveReferral();
        const sellingPlanId = referral && referral.applyPlan ? referral.sellingPlanId : null;
        if (referral && referral.applyPlan && !sellingPlanId) throw new Error('Missing referral plan');
        // Resolve first: a failed product request must leave the previous plan intact.
        await resolvePlanVariant(plan.bags, plan.bag_size, sellingPlanId);
        if (!metaEl.isConnected || eventOptions.signal.aborted) return;
        // These DOM values are temporary; never write to the quiz or browser storage.
        metaEl.dataset.pesoKg = String(weight);
        metaEl.dataset.actividad = activity;
        await updatePlanView();
        saved = true;
      } catch (error) {
        errorEl.textContent = editForm.dataset.error;
        errorEl.hidden = false;
      } finally {
        editingInFlight = false;
        controls.forEach(function (control) { control.disabled = false; });
        editForm.removeAttribute('aria-busy');
        if (!eventOptions.signal.aborted) setLoading(false);
      }
      if (saved) closeEditor();
    }, eventOptions);
  }

  recipeCards.forEach(function (card) {
    card.addEventListener('click', function () {
      const isSelected = card.dataset.selected === 'true';
      if (isSelected && getSelectedRecipes().length === 1) return;
      setRecipeSelected(card, !isSelected);
      updateRecipesRecap();
      updatePlanView();
    }, eventOptions);
  });

  periodCards.forEach(function (card) {
    card.addEventListener('click', function () {
      setPeriodSelected(card);
    }, eventOptions);
  });

  checkoutButtons.forEach(function (button) {
    button.addEventListener('click', handleCheckout, eventOptions);
  });

  retakeLinks.forEach(function (link) {
    link.addEventListener('click', function () {
      const storageKey = link.dataset.revenuehuntStorageKey;
      if (!storageKey) return;
      try {
        window.localStorage.removeItem(storageKey);
      } catch (error) {
        // Navigation still works when storage is blocked by the browser.
      }
    }, eventOptions);
  });

  ensureInitialSelection();
  activePlanRefresh = updatePlanView;
  updatePlanView();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initQuizResult);
  } else {
    initQuizResult();
  }

  document.addEventListener('shopify:section:load', function () {
    activeMetaElement = null;
    activePlanRefresh = null;
    initQuizResult();
  });
  document.addEventListener('shopify:section:unload', function (event) {
    if (activeMetaElement && event.target.contains(activeMetaElement)) {
      if (activeEventController) activeEventController.abort();
      activeMetaElement = null;
      activePlanRefresh = null;
    }
  });
  window.addEventListener('flippo:referral:change', function () {
    if (activePlanRefresh) {
      activePlanRefresh();
    } else {
      initQuizResult();
    }
  });
  window.FlippoQuizResult = window.FlippoQuizResult || {};
  window.FlippoQuizResult.init = initQuizResult;
  window.FlippoQuizResult.buildCheckoutUrl = buildCheckoutUrl;
})();
